module.exports = __webpack_public_path__ + "static/img/b4_body.e9b4088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b4_body.png
// module id = wI5O
// module chunks = 1